import React, { useEffect, useMemo, useState } from "react";
import { API_BASE_URL } from "../../config";
import "./SalycomeHome.css";

const ICONS = {
  mexicano: "🌮",
  pizza: "🍕",
  pastas: "🍝",
  criolla: "🍲",
  mariscos: "🦐",
  parrilla: "🔥",
  hamburguesas: "🍔",
  ensaladas: "🥗",
  postres: "🍰",
  desayuno: "☕",
  sushi: "🍣",
  italiano: "🍷",
};

const DISHES = [
  { name: "Tacos al pastor", tag: "Mexicano" },
  { name: "Pizza artesanal", tag: "Pizza" },
  { name: "Pasta al dente", tag: "Pastas" },
  { name: "Bowl criollo", tag: "Criolla" },
  { name: "Ceviche fresco", tag: "Mariscos" },
  { name: "Burger smash", tag: "Hamburguesas" },
];

const SalycomeHome = () => {
  const [cuisines, setCuisines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/public/cuisines`);
        if (!res.ok) throw new Error(`Error HTTP: ${res.status}`);
        const data = await res.json();
        setCuisines(Array.isArray(data.cuisines) ? data.cuisines : []);
      } catch (e) {
        console.error("Error cargando /public/cuisines", e);
        setError("No pudimos cargar las categorias en este momento.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return cuisines;
    return cuisines.filter((c) => (c.cuisine || "").toLowerCase().includes(q));
  }, [query, cuisines]);

  return (
    <div className="salycome-page">
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-copy">
            <p className="eyebrow">Marketplace Clover</p>
            <h1>
              Pide lo que te gusta,
              <span> sin buscar restaurante</span>
            </h1>
            <p className="sub">
              Descubre tipos de comida, platos populares y delivery rapido.
              Todo con negocios Clover verificados.
            </p>
            <div className="hero-cta">
              <a className="btn-primary" href="#categorias">
                Explorar categorias
              </a>
              <a className="btn-ghost" href="/registro">
                Vender con Clover
              </a>
            </div>
            <div className="search-inline">
              <input
                type="text"
                placeholder="Buscar categoria..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <button className="btn-primary" type="button">
                Buscar
              </button>
            </div>
          </div>
          <div className="hero-card">
            <div className="stat">
              <span className="label">Categorias activas</span>
              <span className="value">{cuisines.length}</span>
            </div>
            <div className="stat">
              <span className="label">Delivery y pickup</span>
              <span className="value">En minutos</span>
            </div>
            <div className="stat">
              <span className="label">Solo Clover</span>
              <span className="value">Verificados</span>
            </div>
          </div>
        </div>
      </section>

      <section className="categories" id="categorias">
        <div className="discover-header">
          <h2>Categorias principales</h2>
        </div>

        {loading && <p className="muted">Cargando...</p>}
        {error && <p className="error">{error}</p>}

        <div className="grid">
          {filtered.map((c) => (
            <article key={c.cuisine} className="card">
              <div className="card-media">
                <div className="icon-badge">{ICONS[c.icon] || "🍽️"}</div>
              </div>
              <div className="card-body">
                <h3 className="cap">{c.cuisine}</h3>
                <p className="meta">{c.count} negocios activos</p>
                {c.examples && c.examples.length > 0 && (
                  <p className="muted small">
                    Ej: {c.examples.slice(0, 3).join(", ")}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>

        {!loading && !error && filtered.length === 0 && (
          <p className="muted">No encontramos categorias con ese nombre.</p>
        )}
      </section>

      <section className="dishes">
        <div className="discover-header">
          <h2>Platos populares</h2>
        </div>
        <div className="grid">
          {DISHES.map((d) => (
            <article key={d.name} className="card dish">
              <div className="dish-tag">{d.tag}</div>
              <h3>{d.name}</h3>
              <p className="muted">Listo para delivery o pickup</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default SalycomeHome;
